import type { FileInProcessing, IOrder } from '../../../../../Model/index.js'

/**
 * Mirrors the fork in Util/OrderState.ts: a preprocessed order that has not started postprocessing is
 * awaiting a human decision (READY_FOR_POSTPROCESSING, or PREPROCESSED_BLOCKED when an item failed),
 * not running.
 */
export const renderMessage = (showCheckboxes: boolean, order: IOrder | null, poolItems: FileInProcessing[]) => {
  if (showCheckboxes) {
    return (
      'Select items which should be used for postprocessing. By pressing the confirm button, you ' +
      'acknowledge that your report will not contain all initially submitted items and might be missing results. ' +
      'Samples or Negative Controls with a sequence count of 0 will never be processed.'
    )
  } else if (order?.orderDone) {
    return 'Order has been processed. Download your report from the order view.'
  } else if (order?.orderPostprocessingStarted) {
    return 'Preprocessing is done. Postprocessing has started, and you will receive an email.'
  } else if (
    poolItems.find(
      (i) => (i.pipelineInformation?.completedAt && !i.pipelineInformation?.qualityVerifiedAt) || i.pipelineInformation?.errorAt
    )
  ) {
    return (
      'Processing has completed. At least one sample could not be processed or seems ' +
      'to have insufficient quality. Postprocessing has not been launched until the issue is rectified.'
    )
  } else if (order?.orderPreprocessed) {
    return 'Preprocessing is done. Review the results and start postprocessing when ready.'
  } else {
    return 'Processing in progress. Please wait, the page refreshes automatically'
  }
}
